import React, { useEffect, useState } from 'react';
import { uploadsAPI } from '../services/api';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const CACHE_KEY = 'companyLogo';
const EVENT = 'company-logo-changed';

const read = () => { try { return JSON.parse(localStorage.getItem(CACHE_KEY)); } catch { return null; } };
let cached = read();
let inflight = null;
let fetchedOnce = false;

const fetchLogo = () => {
  if (!inflight) {
    fetchedOnce = true;
    inflight = fetch(`${BACKEND_URL}/api/branding`)
      .then(r => r.json())
      .then(c => { setLogo({ dark: c.logo_url || '', light: c.logo_light_url || '', version: c.version }); })
      .catch(() => {})
      .finally(() => { inflight = null; });
  }
  return inflight;
};

export const applyFavicon = (version) => {
  const href = `${BACKEND_URL}/api/branding/favicon${version ? `?v=${version}` : ''}`;
  [['icon', 'link[rel="icon"][type="image/png"]'], ['apple-touch-icon', 'link[rel="apple-touch-icon"]']].forEach(([rel, sel]) => {
    let link = document.querySelector(sel);
    if (!link) { link = document.createElement('link'); link.rel = rel; if (rel === 'icon') { link.type = 'image/png'; link.sizes = '192x192'; } document.head.appendChild(link); }
    if (link.href !== href) link.href = href;
  });
};

export const setLogo = (logos) => {
  cached = { dark: logos?.dark || '', light: logos?.light || '', version: logos?.version || String(Date.now()) };
  localStorage.setItem(CACHE_KEY, JSON.stringify(cached));
  applyFavicon(cached.version);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: cached }));
};

export const refreshBranding = () => { inflight = null; fetchedOnce = false; return fetchLogo(); };

export const useCompanyLogo = (variant = 'dark') => {
  const [logos, setState] = useState(cached);
  useEffect(() => {
    const onChange = (e) => setState(e.detail);
    window.addEventListener(EVENT, onChange);
    if (!fetchedOnce) fetchLogo();
    return () => window.removeEventListener(EVENT, onChange);
  }, []);
  if (!logos) return '';
  return variant === 'light' ? (logos.light || logos.dark) : (logos.dark || logos.light);
};

const SIZES = { sm: 'h-8', md: 'h-10', ml: 'h-12', lg: 'h-14', xl: 'h-16 sm:h-16 lg:h-[84px]' };
const TEXT_SIZES = { sm: 'text-xl', md: 'text-2xl', ml: 'text-2xl', lg: 'text-3xl', xl: 'text-4xl' };

const Logo = ({ variant = 'dark', size = 'md', className = '' }) => {
  const logo = useCompanyLogo(variant);
  if (logo) {
    return (
      <img
        data-testid="site-logo-image"
        src={uploadsAPI.resolveUrl(logo)}
        alt="OTOPIECES.COM"
        className={`${SIZES[size]} w-auto ${size === 'xl' ? 'max-w-[150px] min-[380px]:max-w-[210px] sm:max-w-[220px] md:max-w-[170px] lg:max-w-[280px]' : 'max-w-[220px]'} object-contain ${className}`}
      />
    );
  }
  return (
    <span data-testid="site-logo-text" className={`${TEXT_SIZES[size]} font-bold tracking-tight ${className}`}>
      <span className={variant === 'dark' ? 'text-white' : 'text-[#1e3a5f]'}>OTO</span>
      <span className="text-orange-500">PIECES.COM</span>
    </span>
  );
};

export default Logo;
